import { useSetAtom } from "jotai";
import { sizes } from "library/constants";
import { chatPanelOpenAtom } from "store";
import styled from "styled-components";

import { useHasGivenConsent } from "hooks/useHasGivenConsent";

import { ReactComponent as ChatIcon } from "assets/icons/chatIcon.svg";

export function ChatToggleBtn() {
  const setChatPanelOpen = useSetAtom(chatPanelOpenAtom);
  const hasGivenConsent = useHasGivenConsent();

  return (
    <Container>
      <Wrap
        $disabled={!hasGivenConsent}
        onClick={() => {
          if (!hasGivenConsent) return;
          setChatPanelOpen(true);
        }}
      >
        <ChatIcon />
      </Wrap>
    </Container>
  );
}

const Container = styled.div`
  position: fixed;
  bottom: 50px;
  left: 50%;
  margin-left: ${sizes.appContentWidthDesktop / 2 + 50}px;
`;
const Wrap = styled.div<{ $disabled?: boolean }>`
  background-color: ${({ theme }) => theme.palette.purpleDark};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  width: 70px;
  height: 70px;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  box-shadow: 2px 3px 8.9px 0px #00000040;
  cursor: ${({ $disabled }) => ($disabled ? "" : "pointer")};

  transition: all 0.2s ease-in-out;

  &:hover {
    transform: ${({ $disabled }) => ($disabled ? "" : "scale(1.1)")};
  }
`;
